export const bannedStatesForInternationalPayments = ['TX', 'VT'];
